import {
  getErrorMessage,
  getAuthenticationHeaders,
  generateQueryString,
  generateObjectFromList,
  getErrorMessageFromFailureArraySingle,
  getErrorTableDataFromFailureArrayMultiple,
  getErrorMessageForBlob,
} from './utils';
import apiProvider from './provider';
import { API_BASE_URL } from '../globals';
import { GET_RFQ_LIST,
  CREATE_RFQ_PLAN,
  EDIT_LINE_ITEM_RFQ,
  DELETE_LINE_ITEM_RFQ,
  EDIT_RFQ_PLAN,
  DELETE_RFQ_PLAN,
  EDIT_STATUS_RFQ,
  EDIT_STATUS_RFQ_AMENDED,
  FINALISE_QUOTE_NEXT,
  BID_DETAILS,
  EDIT_REFERENCE_RATE_RFQ,
  RFQ_DETAIL_BID_LINE_ITEM,
  FINALISE_SELECTED_BID,
  FETCH_BID_ACTIVITY,
  FETCH_RFQ_DETAILS,
  FETCH_LINE_ITEM_ACTIVITY,
  SELECT_BID_LINE_ITEM,
  ADD_LINE_ITEM,
  SEND_RFQ,
  REJECT_BID,
  ADD_LINE_ITEM_RFQ,
  RFQ_BID_COMPARISON,
  RFQ_BID_PREFILLED_DATA_DOWNLOAD,
  RFQ_UPLOAD_BID_EXCEL,
  RFQ_DOWNLOAD_LINE_ITEM_EXCEL,
  RFQ_DOWNLOAD_ROUND_COMPARISON_LINE_ITEMS,
  RFQ_DOWNLOAD_LINE_ITEM_BIDS_EXCEL,
  RFQ_UPDATE_ROUND,
  EXTEND_DEADLINE_RFQ,
  RFQ_DOWNLOAD_EXCEPTION_REPORT,
  GET_ALL_PORTS,
  RFQ_UPLOAD_BID_EXCEL_FF,
  RFQ_BID_PREFILLED_DATA_DOWNLOAD_FF,
  RFQ_DOWNLOAD_SAMPLE_LINE_ITEMS,
  RFQ_DOWNLOAD_SAMPLE_REFERENCE_RATE,
  RFQ_DOWNLOAD_IMPACT_ANALYSIS_REPORT,
  RFQ_DOWNLOAD_BIDS_RANKING,
  RFQ_DOWNLOAD_SAP_FILE,
  DOWNLOAD_TNC_RFQ_SHIPPER,
  DOWNLOAD_TNC_RFQ_SHIPPING_LINE,
  DOWNLOAD_SUMMARY_SHEET_RFQ,
  RFQ_MIS_REPORTS,
  RFQ_UPLOAD_BULK_AMENDMENT,
  RFQ_VENDOR_LINE_ITEM_AMENDMENT,
  RFQ_DOWNLOAD_AMENDMENT_REPORT,
  RFQ_FETCH_RANKED_BIDS,
  RFQ,
  RFQ_BIDS,
  FETCH_AMENDMENT_VERSION_NAMES,
  RFQ_MASTER_CHARGES,
  RFQ_RATE_MASTERS,
  RFQ_RATE_MASTERS_DOWNLOAD,
  GET_RFQ_COMMENTS,
  RFQ_BID_REVOKE_PREFILLED_DATA_DOWNLOAD,
  RFQ_BULK_REVOKE_EXCEL,
  RFQ_SHIPPINGLINE_PLAN,
  RFQ_DEADLINE_UPDATE,
  RFQ_FETCH_POL_LIST_FOR_LINE_ITEMS,
  RFQ_DELETE_SENT_BID,
  RFQ_BULK_REQUEST,
  BULK_EDIT_LINE_ITEM_RFQ,
  RFQ_BULK_EDIT_DOWNLOAD,
  RFQ_FRC_REPORT,
  RFQ_ACTIVE_RFQ_NAMES,
  RFQ_DELETE_SAVED_BID,
  RFQ_BULK_REQUEST_SUMMARY,
  RFQ_DASHBOARD_SUMMARY,
  BULK_ADD_LINE_ITEM_RFQ,
  RFQ_SHIPPINGLINE_DASHBOARD_SUMMARY,
  RFQ_WITHDRAW_AMENDMENT,
  RFQ_BID_HISTORY,
  RFQ_BID_CHARGES,
  RFQ_GET_TNC_MASTER,
  RFQ_GET_DEFAULT_TNC,
  RFQ_DOWNLOAD_TNC_EXCEL,
  RFQ_UPDATE_TNC_MASTER,
  RFQ_ADD_ONE_TNC,
  RFQ_UPLOAD_TNC_EXCEL,
  RFQ_DOWNLOAD_TNC_SAMPLE_EXECEL,
  RFQ_DELETE_TNC_MASTER,
  RFQ_UPLOAD_TNC_DOCUMENT,
  RFQ_DELETE_TNC_DOCUMENT,
  RFQ_GET_CHARGE_MASTER,
  RFQ_SEARCH_CHARGE_MASTER,
  RFQ_EDIT_CHARGE_MASTER,
  RFQ_REGION_LINE_ITEMS,
  RFQ_REGION_DOWNLOAD_SAMPLE_LINE_ITEM,
  RFQ_REGION_DOWNLOAD_LINE_ITEM,
  RFQ_REGION_EDIT_LINE_ITEM,
  RFQ_REGION_ADD_LINE_ITEM,
  CALCULATE_WEIGHTED_AVERAGE,
  RFQ_COMPILED_REPORTS,
  RFQ_BULK_REQUEST_ACTIONS,
  RFQ_FLEXIBLE_REPORTS_MASTER_DATA,
  RFQ_FLEXIBLE_REPORTS_EXCEL,
  RFQ_FLEXIBLE_REPORTS_HISTORY,
  RFQ_NEW_UPDATES,
  BACKGROUND_JOBS_STATUS_POLL,
  RFQ_BIDS_TREND,
  RFQ_EDIT_CONTRACT,
  RFQ_COUNTRY_CODE,
  RFQ_DOWNLOAD_INDIVIDUAL_RATES,
  RFQ_UPLOAD_INDIVIDUAL_RATES,
  RFQ_ALLOW_MULTIPLE_RATES,
  RFQ_PRODUCT_MASTER,
  RFQ_GROUP_ID,
  RFQ_DOWNLOAD_VOLUME_SHEET,
  RFQ_DOWNLOAD_SAP_RESPONSE_REPORT,
  GLOBAL_RANKED_BIDS_REPORT,
  RFQ_DOWNLOAD_ROUND_COMPARISON_REPORT,
  RFQ_DOWNLOAD_ROUND_COMPARISON,
  RFQ_QUOTE_TEMPLATE_FILE,
  RFQ_QUOTE_TEMPLATE_SUPPLIERS,
  RFQ_QUOTE_BULK_CREATE,
  RFQ_QUOTE_SEND,
  RFQ_QUOTE_BULK_SEND,
  RFQ_QUOTE_REVOKE,
  RFQ_LINE_ITEM_FETCH,
  RFQ_LINE_ITEM_FORM_FIELDS,
  RFQ_LINE_ITEM_CREATE,
  RFQ_LINE_ITEM_BULK_UPLOAD,
  RFQ_LINE_ITEM_TEMPLATE,
  RFQ_LINE_ITEM_SEND,
  RFQ_LINE_ITEM_BULK_SEND,
  RFQ_LINE_ITEM_QUOTES_DOWNLOAD,
  RFQ_REFERENCE_QUOTE_DOWNLOAD,
  RFQ_TENDER_QUOTES_DOWNLOAD,
  RFQ_TENDER_FORM_FIELDS,
  RFQ_TENDER_CREATE,
  RFQ_TENDER_DETAILS,
  RFQ_TENDER_EDITABLE_CHARGES,
} from './routes';
import { POST, DELETE, DELETE_QUERIED, GET, PATCH, ApiResponseWrapper } from './apiHandler';
import ApiDto from 'src/dto/ApiDto';
import { APIResponseType } from 'src/Library/Types';
import { SendRFQDtoV2 } from 'src/transformers/classes/rfq/CRFQSendRFQForm.types';
import { AxiosResponse } from 'axios';

export const finaliseSelectedBidSingleApi = async (params:any) => {
  try {
    const selectedBidResponse = await apiProvider.post(
      `${API_BASE_URL}${FINALISE_SELECTED_BID}`, params, {
        headers: getAuthenticationHeaders(),
      },
    );
    const failureArray = selectedBidResponse.data.data ?
      selectedBidResponse.data.data.failureArray : null;
    const errorExists = failureArray && failureArray.length;
    if (errorExists) {
      return {
        isSuccess: false,
        errorMessage: getErrorMessageFromFailureArraySingle(failureArray),
      };
    }
    return {
      isSuccess: true,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const finaliseSelectedBidMultipleApi = async(params:any) => {
  try {
    const selectedBidResponse = await apiProvider.post(
      `${API_BASE_URL}${FINALISE_SELECTED_BID}`, params, {
        headers: getAuthenticationHeaders(),
      },
    );
    const failureArray = selectedBidResponse.data.data ?
      selectedBidResponse.data.data.failureArray : null;
    const errorExists = failureArray && failureArray.length;
    if (errorExists) {
      return {
        isSuccess: false,
        errorData: getErrorTableDataFromFailureArrayMultiple(failureArray,
          'destinationPortName', 'lineItem'),
      };
    }
    return {
      isSuccess: true,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const createRFQPlanApi = async (params) => {
  try {
    const createResponse = await apiProvider.post(`${API_BASE_URL}${CREATE_RFQ_PLAN}`, params, {
      headers: getAuthenticationHeaders(),
    });
    let isSuccess = true;
    if (createResponse.data && createResponse.data.data &&
      createResponse.data.data.failureArray && createResponse.data.data.failureArray.length) {
      isSuccess = false;
    }
    return {
      isSuccess,
      data: createResponse.data.data || {},
      failureArray: isSuccess ? null : createResponse.data.data.failureArray,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchRFQListApi = async (params) => {
  try {
    let paramArray: any = [];
    for (const key in params) {
      if (Array.isArray(params[key])) {
        const paramData = generateObjectFromList(key, params[key]);
        paramArray = paramArray.concat(paramData);
      } else {
        const obj = { key, val: params[key] };
        paramArray.push(obj);
      }
    }
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider.get(`${API_BASE_URL}${GET_RFQ_LIST}` +
    `?${generateQueryString(paramArray)}`,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchAllPorts = async (params) => {
  try {
    const portsResponse = await apiProvider.post(`${API_BASE_URL}${GET_ALL_PORTS}`, params, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: portsResponse.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadSampleLineItems = async (body:any) => {
  try {
    const response = await apiProvider
      .post(`${API_BASE_URL}${RFQ_DOWNLOAD_SAMPLE_LINE_ITEMS}`, body, {
        headers: getAuthenticationHeaders(),
        responseType: 'blob',
      });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
      decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadSampleReferenceRate = async (body:any) => {
  try {
    const response = await apiProvider
      .post(`${API_BASE_URL}${RFQ_DOWNLOAD_SAMPLE_REFERENCE_RATE}`, body, {
        headers: getAuthenticationHeaders(),
        responseType: 'blob',
      });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
      decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadLineitems = async (body:any, isEdit?: boolean) => {
  try {
    let api = `${API_BASE_URL}${RFQ_DOWNLOAD_LINE_ITEM_EXCEL}`;
    if (isEdit) {
      api = `${API_BASE_URL}${RFQ_BULK_EDIT_DOWNLOAD}`;
    }
    const response = await apiProvider
      .post(api, body, {
        headers: getAuthenticationHeaders(),
        responseType: 'blob',
      });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
      decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

/**
 * Round Comparison (Line Items): the line-item dump stacked across every round, one row per
 * (line item, round) with Round as the leftmost column. Takes the same filter body as
 * `downloadLineitems` because the backend resolves line items through the same `fetchDetailedV2` path.
 */
export const downloadRoundComparisonLineItems = async (body: any) => {
  try {
    const response = await apiProvider
      .post(`${API_BASE_URL}${RFQ_DOWNLOAD_ROUND_COMPARISON_LINE_ITEMS}`, body, {
        headers: getAuthenticationHeaders(),
        responseType: 'blob',
      });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
        decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadLineitemBids = async (body:any) => {
  try {
    const response = await apiProvider
      .post(`${API_BASE_URL}${RFQ_DOWNLOAD_LINE_ITEM_BIDS_EXCEL}`, body, {
        headers: getAuthenticationHeaders(),
        responseType: 'blob',
      });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
        decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadRankingBids = async (body:any) => {
  try {
    const response = await apiProvider
      .post(`${API_BASE_URL}${RFQ_DOWNLOAD_BIDS_RANKING}`, body, {
        headers: getAuthenticationHeaders(),
        responseType: 'blob',
      });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
        decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const editReferenceRateApi = async (params:any) => {
  try {
    const editReferenceRateResponse = await apiProvider
      .post(`${API_BASE_URL}${EDIT_REFERENCE_RATE_RFQ}`, params, {
        headers: getAuthenticationHeaders(),
      });
    return {
      data: editReferenceRateResponse.data,
      isSuccess: true,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const extendDeadlineApi = async (params: any) => {
  try {
    const response = await apiProvider
      .post(`${API_BASE_URL}${EXTEND_DEADLINE_RFQ}`, params, {
        headers: getAuthenticationHeaders(),
      });
    return {
      data: response.data,
      isSuccess: true,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const editStatusApi = async (params:typeof ApiDto.FinalizeLineItemDtoV2) => {
  return POST(`${API_BASE_URL}${EDIT_STATUS_RFQ}`, params);
};

// RFQ Next phase 3 finalise path (CFS, ICD, CHA, BB, Surveyor) — drives the approval-engine trigger
// on the backend (ISS-288748). Replaces editStatusApi for the FINALISED action on these flows.
export const finaliseQuoteApi = async (params: { lineItemIds: string[] }) => {
  return POST(`${API_BASE_URL}${FINALISE_QUOTE_NEXT}`, params);
};

export const editAmendedStatusApi = async (params:typeof ApiDto.UpdateAmendedRFQStatusBulkDto) => {
  return POST(`${API_BASE_URL}${EDIT_STATUS_RFQ_AMENDED}`, params);
};

export const rejectBid = async (body:any) => {
  try {
    const rejectBidResponse: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider
      .post(`${API_BASE_URL}${REJECT_BID}`, { bidIds: body } , {
        headers: getAuthenticationHeaders(),
      });
    let isSuccess = true;
    if (rejectBidResponse.data.data && rejectBidResponse.data.data.failureArray &&
      rejectBidResponse.data.data.failureArray.length) {
      isSuccess = false;
    }
    return {
      isSuccess,
      failureArray: !isSuccess ? rejectBidResponse.data.data.failureArray : null,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const addLineItemToRfq = async (body:any) => {
  try {
    const addLineItem = await apiProvider
      .post(`${API_BASE_URL}${ADD_LINE_ITEM_RFQ}`, body, {
        headers: getAuthenticationHeaders(),
      });
    let isSuccess = true;
    if (addLineItem.data && addLineItem.data.data &&
      addLineItem.data.data.failureArray && addLineItem.data.data.failureArray.length) {
      isSuccess = false;
    }

    return {
      isSuccess,
      data: addLineItem.data.data,
      failureArray: isSuccess ? null : addLineItem.data.data.failureArray,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const bidComparisonData = [{
  origin: 'Abc',
  destination: 'def',
}, {
  origin: 'Abc',
  destination: 'def',
}];

export const fetchBidComparisonApi = async (lineItemId, selectedBidIds) => {
  try {
    const params = {
      lineItemId,
      bidIds: selectedBidIds,
    };
    const bidComparisonResponse: any = await apiProvider
      .post(`${API_BASE_URL}${RFQ_BID_COMPARISON}`,
        params,
      {
        headers: getAuthenticationHeaders(),
      },
      );
    const computedComparisonData = bidComparisonResponse.data.data.bids.map(bidData =>
    Object.assign({}, bidData,
      {
        containerSizeAndType: `${bidData.containerSize ? bidData.containerSize :
          ''} ${bidData.containerType ? bidData.containerType : ''}`,
      }));
    return {
      isSuccess: true,
      data: computedComparisonData, // bidComparisonResponse.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const editLineItemApi = async (params:any) => {
  try {
    const editLineItem = await apiProvider
      .post(`${API_BASE_URL}${EDIT_LINE_ITEM_RFQ}`,  params , {
        headers: getAuthenticationHeaders(),
      });
    let isSuccess = true;
    if (editLineItem.data && editLineItem.data.failureArray &&
      editLineItem.data.failureArray.length) {
      isSuccess = false;
    }
    return {
      isSuccess,
      data: editLineItem.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const deleteLineItemApi = async (params:any) => {
  try {
    const deleteLineItem = await apiProvider
        .post(`${API_BASE_URL}${DELETE_LINE_ITEM_RFQ}`, params, {
          headers: getAuthenticationHeaders(),
        });
    let isSuccess = true;
    if (deleteLineItem.data && deleteLineItem.data.failureArray &&
        deleteLineItem.data.failureArray.length) {
      isSuccess = false;
    }
    return {
      isSuccess,
      data: deleteLineItem.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const editRFQPlanApi = async (params:any) => {
  try {
    const editLineItem = await apiProvider
      .post(`${API_BASE_URL}${EDIT_RFQ_PLAN}`,  params , {
        headers: getAuthenticationHeaders(),
      });
    let isSuccess = true;
    if (editLineItem.data && editLineItem.data.failureArray &&
      editLineItem.data.failureArray.length) {
      isSuccess = false;
    }
    return {
      isSuccess,
      data: editLineItem.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const deleteRFQPlanApi = async (params:any) => {
  try {
    const deleteLineItem = await apiProvider
        .post(`${API_BASE_URL}${DELETE_RFQ_PLAN}`, params, {
          headers: getAuthenticationHeaders(),
        });
    let isSuccess = true;
    if (deleteLineItem.data && deleteLineItem.data.failureArray &&
        deleteLineItem.data.failureArray.length) {
      isSuccess = false;
    }
    return {
      isSuccess,
      data: deleteLineItem.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchRankedBidsForLineItem = async (params) => {
  return POST(`${API_BASE_URL}${RFQ_FETCH_RANKED_BIDS}`, params);
};

export const fetchDetailsRFQ = async (params:any) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${FETCH_RFQ_DETAILS}`,
      params,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    const rfqDetailsResponse = response.data.data;
    const rfqDetailsData = (rfqDetailsResponse && rfqDetailsResponse.lineItems.length) ?
      rfqDetailsResponse.lineItems.map((rfqDetailData: any) => (
        Object.assign({}, rfqDetailData,
          {
            statusAndStatusTime: [rfqDetailData.status, rfqDetailData.lastStatusUpdatedAt],
          })
      )) : [];
    const data: any = Object.assign({}, rfqDetailsResponse, { lineItems: rfqDetailsData });
    return {
      data,
      isSuccess: true,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const sendRFQApi = async (params: SendRFQDtoV2) => {
  try {
    const editReferenceRateResponse = await apiProvider
      .post(`${API_BASE_URL}${SEND_RFQ}`, params, {
        headers: getAuthenticationHeaders(),
      });
    return {
      data: editReferenceRateResponse.data,
      isSuccess: true,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchBidsForLineItemApi = async (
  params: typeof ApiDto.FetchBidsLineItemDtoV2 & { bidsOrderedByFilter?: string; sortBy?: string },
) => {
  return POST(`${API_BASE_URL}${RFQ_DETAIL_BID_LINE_ITEM}`, params);
};

export const selectBidLineItemApi = async (bidId:any) => {
  try {
    const bidLineItemResponse = await apiProvider
      .post(`${API_BASE_URL}${SELECT_BID_LINE_ITEM}`, {
        bidId: bidId.toString(),
      }, {
        headers: getAuthenticationHeaders(),
      });
    return {
      isSuccess: true,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchBidDetailsApi = async (bidId:any) => {
  try {
    const bidLineItemResponse: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider
      .get(`${API_BASE_URL}${BID_DETAILS}`, {
        params: {
          bidId,
        },
        headers: getAuthenticationHeaders(),
      });
    const dataToList:any = [];
    dataToList.push(bidLineItemResponse.data.data);
    return {
      isSuccess: true,
      data: dataToList,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const updateRfqRound = async (body) => {
  try {
    const response = await apiProvider
      .post(`${API_BASE_URL}${RFQ_UPDATE_ROUND}`, body, {
        headers: getAuthenticationHeaders(),
      });
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchLineItemActivityApi = async(lineItemId:any) => {
  try {
    const bidLineItemResponse: AxiosResponse<ApiResponseWrapper> = await apiProvider
      .get(`${API_BASE_URL}${FETCH_LINE_ITEM_ACTIVITY}`, {
        params: {
          lineItemId,
        },
        headers: getAuthenticationHeaders(),
      });
    return {
      isSuccess: true,
      data: bidLineItemResponse.data.data.events,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

// rfq-next line item activity (ISS-288711). Hits the new approval-engine-backed
// endpoint GET /rfq/line-item/:id/activity. Response mirrors the legacy fetchV2
// shape ({ events: [...] }) so the shared ActivityRFQ drawer is reused.
export const fetchRfqNextLineItemActivityApi = async (
  lineItemId: string,
  // ISS-291244 — an amended line item has two trails, one per tab; the flag picks the Amended tab's.
  isOpenForAmendment = false,
) => {
  const query = isOpenForAmendment ? '?isOpenForAmendment=true' : '';
  const response = await GET(`${API_BASE_URL}${RFQ_LINE_ITEM_FETCH}/${lineItemId}/activity${query}`);
  if (response.isSuccess) {
    return {
      isSuccess: true,
      data: response.data?.events ?? [],
    };
  }
  return {
    isSuccess: false,
    errorMessage: response.errorMessage,
  };
};

export const fetchBidActivityApi = async(bidId:any) => {
  try {
    const bidLineItemResponse: AxiosResponse<ApiResponseWrapper> = await apiProvider
      .get(`${API_BASE_URL}${FETCH_BID_ACTIVITY}`, {
        params: {
          bidId,
        },
        headers: getAuthenticationHeaders(),
      });
    return {
      isSuccess: true,
      data: bidLineItemResponse.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getDownloadBidData = async (params: any) => {
  try {
    let paramArray: any = [];
    for (const key in params) {
      if (Array.isArray(params[key])) {
        const paramData = generateObjectFromList(key, params[key]);
        paramArray = paramArray.concat(paramData);
      } else {
        const obj = { key, val: params[key] };
        paramArray.push(obj);
      }
    }
    // const response = await apiProvider.post(
    //   `${API_BASE_URL}${DOWNLOAD_BID_LIST}` +
    //   `?${generateQueryString(paramArray)}`, {},
    //   {
    //     headers: getAuthenticationHeaders(),
    //     responseType: 'blob',
    //   },
    // );
    return {
      isSuccess: false,
      errorMessage: 'test',
      data: [],
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const addLineItemForExistingRFQApi = async(params:any) => {
  try {
    const addLineItemResponse = await apiProvider
    .post(`${API_BASE_URL}${ADD_LINE_ITEM}`, params, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadBidPrefilledData = async(body, userType) => {
  try {
    let response;
    let endpoint = RFQ_BID_PREFILLED_DATA_DOWNLOAD;
    if (userType === 'FF') {
      response = await apiProvider
    .post(`${API_BASE_URL}${RFQ_BID_PREFILLED_DATA_DOWNLOAD_FF}`, body, {
      headers: getAuthenticationHeaders(),
      responseType: 'blob',
    });
    } else {
      if (body.isOpenForAmendment) {
        endpoint = RFQ_BID_REVOKE_PREFILLED_DATA_DOWNLOAD;
      }
      response = await apiProvider
        .post(`${API_BASE_URL}${endpoint}`, body, {
          headers: getAuthenticationHeaders(),
          responseType: 'blob',
        });
    }
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
      decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
      contentType: response.headers['content-type'],
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadExceptionReport = async(rfqPlanId) => {
  try {
    const response = await apiProvider
    .post(`${API_BASE_URL}${RFQ_DOWNLOAD_EXCEPTION_REPORT}`, rfqPlanId, {
      headers: getAuthenticationHeaders(),
      responseType: 'blob',
    });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
      decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadImpactAnalysisReport = async(rfqPlanId) => {
  try {
    const response = await apiProvider
    .post(`${API_BASE_URL}${RFQ_DOWNLOAD_IMPACT_ANALYSIS_REPORT}`, rfqPlanId, {
      headers: getAuthenticationHeaders(),
      responseType: 'blob',
    });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
      decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadSAPFile = async(params) => {
  try {
    const response = await apiProvider
    .post(`${API_BASE_URL}${RFQ_DOWNLOAD_SAP_FILE}`, params, {
      headers: getAuthenticationHeaders(),
      responseType: 'blob',
    });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
      decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadAmendmentReport = async(rfqPlanId) => {
  try {
    const response = await apiProvider
    .post(`${API_BASE_URL}${RFQ_DOWNLOAD_AMENDMENT_REPORT}`, rfqPlanId, {
      headers: getAuthenticationHeaders(),
      responseType: 'blob',
    });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
      decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const bidBulkRevoke = async(body, userType) => {
  try {
    const response = await apiProvider
    .post(`${API_BASE_URL}${RFQ_BULK_REVOKE_EXCEL}`, body, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const bidUploadExcel = async (
  body,
  userType
): Promise<APIResponseType<{
  data: {
    requestId: string;
  };
  elapsedTime: number;
  status: string;
  statusCode: number;
}>> => {
  return POST(`${API_BASE_URL}${RFQ_UPLOAD_BID_EXCEL}`, body);
};

export const downloadTnC = async(rfqPlanId) => {
  try {
    const response = await apiProvider
    .post(`${API_BASE_URL}${DOWNLOAD_TNC_RFQ_SHIPPER}`, rfqPlanId, {
      headers: getAuthenticationHeaders(),
      responseType: 'blob',
    });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
      decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadTnCShippingLine = async(rfqPlanId) => {
  try {
    const response = await apiProvider
    .post(`${API_BASE_URL}${DOWNLOAD_TNC_RFQ_SHIPPING_LINE}`, rfqPlanId, {
      headers: getAuthenticationHeaders(),
      responseType: 'blob',
    });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
      decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadSummarySheet = async(rfqPlanId) => {
  try {
    const response = await apiProvider
    .post(`${API_BASE_URL}${DOWNLOAD_SUMMARY_SHEET_RFQ}`, rfqPlanId, {
      headers: getAuthenticationHeaders(),
      responseType: 'blob',
    });
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
      decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getRFQMISReport = async (params) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider.get(
      `${API_BASE_URL}${RFQ_MIS_REPORTS}`,
      {
        params,
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const rfqFinalisedBidData = {
  carriersResponded: '0/2',
  lineItems: [
    {
      id: '112',
      destinationPortId: 'MUARA ASAM ASAM ACHORAGE',
      destinationPortName: 'MUARA ASAM ASAM ACHORAGE',
      cargoType: 'Oil',
      round: 2,
      status: 'Approval L3',
      lastStatusUpdatedAt: 1234,
      finalisedBid: {
        cost: 123,
        originPort: 'mumbai',
        shippingLine: 'happag lloyd',
        selected: true,
        bidId: '123',
      },
      startDate: 1234,
      endDate: 1234,
      bidDetails: [{
        finalisedBid: {
          cost: 123,
          originPort: 'mumbai',
          shippingLine: 'happag lloyd',
          selected: true,
          bidId: '1237',
        },
        startDate: 1234,
        endDate: 1234,
      }, {
        finalisedBid: {
          cost: 123,
          originPort: 'mumbai',
          shippingLine: 'happag lloyd',
          selected: true,
          bidId: '1236',
        },
        startDate: 1234,
        endDate: 1234,
      }, {
        finalisedBid: {
          cost: 123,
          originPort: 'mumbai',
          shippingLine: 'happag lloyd',
          selected: true,
          bidId: '1235',
        },
        startDate: 1234,
        endDate: 1234,
      }, {
        finalisedBid: {
          cost: 123,
          originPort: 'mumbai',
          shippingLine: 'happag lloyd',
          selected: true,
          bidId: '1234',
        },
        startDate: 1234,
        endDate: 1234,
      }],
    }],
  name: 'Shubhangi',
  originPorts: [{ id: 'HAYPOINT', name: 'HAYPOINT' }],
  period: '1 month',
  preparationDate: '2019-03-05',
  startDate: '2019-03-09',
  status: 'OPEN',
  tentativeContainers: 4,
};

export const getMasterCharges = async (params) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider
      .get(`${API_BASE_URL}${RFQ_MASTER_CHARGES}`,
        { params, headers: getAuthenticationHeaders() },
      );
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

// Editable charges for a tender line item (used by the vendor amendment flow,
// where charges are resolved per line item rather than by plan type/mode).
export const getTenderEditableCharges = async (lineItemId: string) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider.get(
      `${API_BASE_URL}${RFQ_TENDER_EDITABLE_CHARGES}/${lineItemId}`,
      { headers: getAuthenticationHeaders() },
    );
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchRfqRateMaster = async (body) => {
  return POST(`${API_BASE_URL}${RFQ_RATE_MASTERS}`, body);
};

export const downloadRfqRateMaster = async (body) => {
  return POST(`${API_BASE_URL}${RFQ_RATE_MASTERS_DOWNLOAD}`, body, undefined, true);
};

export const uploadBulkAmendment = async (params) => {
  try {
    const response = await apiProvider
      .post(`${API_BASE_URL}${RFQ_UPLOAD_BULK_AMENDMENT}`,
      params,
      { headers: getAuthenticationHeaders() },
    );
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

// Amendment submit for the non-shipping-line vendor types (CFS/ICD/CHA/etc.).
export const uploadVendorLineItemAmendment = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${RFQ_VENDOR_LINE_ITEM_AMENDMENT}`,
      params,
      { headers: getAuthenticationHeaders() },
    );
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchAmendmentVersionNames = async (rfqPlanId) => {
  return await GET(`${API_BASE_URL}${FETCH_AMENDMENT_VERSION_NAMES}`, rfqPlanId);
};

export const fetchCommentsApi = async (params) => {

  return GET(`${API_BASE_URL}${GET_RFQ_COMMENTS}`, params);
};

export const deleteSavedBids = async ({ rfqPlanId, ...params }) => {
  return await DELETE_QUERIED(`${API_BASE_URL}${RFQ_DELETE_SAVED_BID(rfqPlanId)}`,
    params);
};

export const deleteSentBid = async (params, rfqPlanId?, isBulkRevoke?: boolean, type?) => {
  const payload = type === 'sentBulkAction' ? params : {
    rfqPlanId,
    isBulkRevoke,
    data: params,
  }
  return await POST(`${API_BASE_URL}${RFQ_DELETE_SENT_BID}`, payload);
};

export const updateDeadline = async (params) => {
  return POST(`${API_BASE_URL}${RFQ_DEADLINE_UPDATE}`, params);
};

export const fetchPOLsForLineItems = async (params, rfqPlanId) => {
  return GET(`${API_BASE_URL}${RFQ_FETCH_POL_LIST_FOR_LINE_ITEMS(rfqPlanId)}`, params);
};

export const getDownloadJobs = async (params: { tabId: 'bulkDownload' | 'bulkAction'; }) => {
  const ENDPOINT = params.tabId === 'bulkDownload' ? RFQ_BULK_REQUEST : RFQ_BULK_REQUEST_ACTIONS;
  return POST(`${API_BASE_URL}${ENDPOINT}`, params);
};

export const getDownloadJobSummary = async (params) => {
  return POST(`${API_BASE_URL}${RFQ_BULK_REQUEST_SUMMARY}`, params);
}

export const postBulkEditLineItem = async (params) => {
  return POST(`${API_BASE_URL}${BULK_EDIT_LINE_ITEM_RFQ}`, params);
};

export const postBulkAddLineItem = async (params) => {
  return POST(`${API_BASE_URL}${BULK_ADD_LINE_ITEM_RFQ}`, params);
};

export const postFcrReport = async (params) => {
  return POST(`${API_BASE_URL}${RFQ_FRC_REPORT}`, params);
};

export const fetchActiveRfqNames = async (params) => {
  return POST(`${API_BASE_URL}${RFQ_ACTIVE_RFQ_NAMES}`, params);
};

export const fetchRfqDashboardSummary = async (params) => {
  return GET(`${API_BASE_URL}${RFQ_DASHBOARD_SUMMARY}?${generateQueryString(params)}`);
}

export const fetchShippingLineRfqDashboardSummary = async (params) => {
  return GET(`${API_BASE_URL}${RFQ_SHIPPINGLINE_DASHBOARD_SUMMARY}?${generateQueryString(params)}`);
}

export const postWithdrawAmendment = async (params) => {
  return POST(`${API_BASE_URL}${RFQ_WITHDRAW_AMENDMENT}`, params);
};

export const getBidHistory = async (params) => {
  return GET(`${API_BASE_URL}${RFQ_BID_HISTORY(params)}`);
};

export const getTncMaster = async (
  params
): Promise<APIResponseType<{
  tncData
}>> => {
  return POST(`${API_BASE_URL}${RFQ_GET_TNC_MASTER}`, params);
};

export const getDefaultTnc = async (params: {
  vendorType: string;
  rfqMode?: string;
  rfqType?: string;
  rfqSubType?: string;
  segment?: string;
  region?: string;
}): Promise<APIResponseType<{ tncData: any[] }>> => {
  return POST(`${API_BASE_URL}${RFQ_GET_DEFAULT_TNC}`, params);
};

export const uploadTncDocument = async (params: {
  internalId: string;
  s3FileLink: string;
  fileName: string;
}) => {
  return POST(`${API_BASE_URL}${RFQ_UPLOAD_TNC_DOCUMENT}`, params);
};

export const deleteTncDocument = async (params: {
  internalId: string;
  documentId: string;
}) => {
  return POST(`${API_BASE_URL}${RFQ_DELETE_TNC_DOCUMENT}`, params);
};

export const downloadTncExcel = async (params) => {
  return POST(`${API_BASE_URL}${RFQ_DOWNLOAD_TNC_EXCEL}`, params, getAuthenticationHeaders(), true);
};

export const updateTncMaster = async (params) => {
  return POST(`${API_BASE_URL}${RFQ_UPDATE_TNC_MASTER}`, params);
};

export const deleteTncMaster = async (params) => {
  return POST(`${API_BASE_URL}${RFQ_DELETE_TNC_MASTER}`, params);
};

export const addOneTncMaster = async (params) => {
  return POST(`${API_BASE_URL}${RFQ_ADD_ONE_TNC}`, params);
};

export const uploadTncExcel = async (params: {
  s3FileLink: string;
}) => {
  return GET(`${API_BASE_URL}${RFQ_UPLOAD_TNC_EXCEL}`, params);
};

export const downloadTncSampleExcel = async (params: {}) => {
  return GET(`${API_BASE_URL}${RFQ_DOWNLOAD_TNC_SAMPLE_EXECEL}`, params, 'blob');
};

export const getChargeMaster = async (
  params
): Promise<APIResponseType<any>> => {
  return POST(`${API_BASE_URL}${RFQ_GET_CHARGE_MASTER}`, params);
};

export const searchChargeMaster = async (params: { queryString: string; }) => {
  return GET(`${API_BASE_URL}${RFQ_SEARCH_CHARGE_MASTER}`, params);
};

export const editChargeMaster = async (
  params
): Promise<APIResponseType<string>> => {
  return POST(`${API_BASE_URL}${RFQ_EDIT_CHARGE_MASTER}`, params);
};

export const getRegionLineItems = async (body) => {
  return POST(`${API_BASE_URL}${RFQ_REGION_LINE_ITEMS}`, body);
};

export const downloadMastersRegionLineItems = async (body, isEdit = false) => {
  let apiUrl = RFQ_REGION_DOWNLOAD_LINE_ITEM;
  if (!isEdit) {
    apiUrl = RFQ_REGION_DOWNLOAD_SAMPLE_LINE_ITEM;
    return POST(`${API_BASE_URL}${apiUrl}`, body, getAuthenticationHeaders(), true);
  }
  return GET(`${API_BASE_URL}${apiUrl}`, body, 'blob');
};

export const postMasterRegionsLineItem = async (params, isEdit = false) => {
  let apiUrl = RFQ_REGION_ADD_LINE_ITEM;
  if (isEdit) {
    apiUrl = RFQ_REGION_EDIT_LINE_ITEM;
  }
  return POST(`${API_BASE_URL}${apiUrl}`, params);
};

export const getWeightedAverage = async (params: typeof ApiDto.WeightedAverageRequestDto) => {
  const url = `${API_BASE_URL}${CALCULATE_WEIGHTED_AVERAGE}`;
  return POST(url, params);
}

export const getCompiledReports = async (params: typeof ApiDto.GenerateCompiledReportDto) => {
  const url = `${API_BASE_URL}${RFQ_COMPILED_REPORTS}`;
  return POST(url, params);
}

export const getFlexibleReportsMasterData = async (params = {}) => {
  return GET(`${API_BASE_URL}${RFQ_FLEXIBLE_REPORTS_MASTER_DATA}`, params);
};

export const getFlexibleReportsHistory = async (params = {}) => {
  return GET(`${API_BASE_URL}${RFQ_FLEXIBLE_REPORTS_HISTORY}`, params);
};

export const postFlexibleReportsAsDraft = async (params = {}) => {
  return POST(`${API_BASE_URL}${RFQ_FLEXIBLE_REPORTS_HISTORY}`, params);
};

export const deleteFlexibleReportsDraft = async (params = {}) => {
  return DELETE(`${API_BASE_URL}${RFQ_FLEXIBLE_REPORTS_HISTORY}`, params);
};

export const patchFlexibleReports = async (params = {}) => {
  return PATCH(`${API_BASE_URL}${RFQ_FLEXIBLE_REPORTS_HISTORY}`, params);
};

export const downloadFlexibleReportsExcel = async (params) => {
  return POST(`${API_BASE_URL}${RFQ_FLEXIBLE_REPORTS_EXCEL}`, params, getAuthenticationHeaders(), true);
};

export const getRfqPlanNewUpdates = async (params) => {
  const apiUrl = `${API_BASE_URL}${RFQ_NEW_UPDATES}/${params}`
  return GET(apiUrl);
};
export const backgroundJobsStatusPoll = async (params) => {
  return GET(`${API_BASE_URL}${BACKGROUND_JOBS_STATUS_POLL}`, params);
}

export const getBidsTrendData = async (params) => {
  const apiUrl = `${API_BASE_URL}${RFQ_BIDS_TREND}`
  return POST(apiUrl, params);
};

export const patchContractId = async (params) => {
  const apiUrl = `${API_BASE_URL}${RFQ_EDIT_CONTRACT}`
  return PATCH(apiUrl, params);
};
export const getCountryCode = async (params) => {
  return GET(`${API_BASE_URL}${RFQ_COUNTRY_CODE}`, params);
}

export const downloadSampleReferenceIndividualRatesExcel = async (params) => {
  return POST(`${API_BASE_URL}${RFQ_DOWNLOAD_INDIVIDUAL_RATES}`, params, getAuthenticationHeaders(), true);
};

export const uploadReferenceIndividualRatesExcel = async (params) => {
  return POST(`${API_BASE_URL}${RFQ_UPLOAD_INDIVIDUAL_RATES}`, params);
};

export const allowMultipleRatesAction = async (params) => {
  return POST(`${API_BASE_URL}${RFQ_ALLOW_MULTIPLE_RATES}`, params);
};

export const fetchProductListFromProductMaster = (params) => {
  return GET(`${API_BASE_URL}${RFQ_PRODUCT_MASTER}`, params);
}
export const getRfqGroup = async (params) => {
  return GET(`${API_BASE_URL}${RFQ_GROUP_ID}`, params);
}

export const downloadVolumeSheet = async (params: {}) => {
  return GET(`${API_BASE_URL}${RFQ_DOWNLOAD_VOLUME_SHEET}`, params, 'blob');
};

export const downloadAPIResponseReport = async (params: {}) => {
  return GET(`${API_BASE_URL}${RFQ_DOWNLOAD_SAP_RESPONSE_REPORT}`, params, 'blob');
};

export const postRfqPlanRankedBidsReport = async (params) => {
  return POST(`${API_BASE_URL}${GLOBAL_RANKED_BIDS_REPORT}`, params);
};

export const downloadRoundComparisonReport = async (params: {}) => {
  return GET(`${API_BASE_URL}${RFQ_DOWNLOAD_ROUND_COMPARISON_REPORT}`, params, 'blob');
};

// rfq-next all-rounds comparison (CFS/ICD/Inter-Carting): charges + counters + bid ranking per round.
export const downloadRoundComparison = async (params: { tenderId: string }) => {
  return GET(`${API_BASE_URL}${RFQ_DOWNLOAD_ROUND_COMPARISON}`, params, 'blob');
};

// ISS-291845 — `isOpenForAmendment` picks the vendor tab: `true` returns only the open-for-amendment
// line items with the sheet locked to the amendment's editable charges and no (Counter) columns;
// `false` returns everything else. Sent on both tabs (unlike the quotes downloads, which omit it on
// Main) because the server needs to tell "Main tab" apart from "a caller with no tab at all", which
// still gets the legacy unscoped workbook.
// ISS-294486 — `supplierIds` (CFS/ICD contractors only) is sent comma-joined: axios has no custom
// params serializer here, so an array would go out as `supplierIds[]=`. Omit it for every contractor.
export const downloadBulkQuoteTemplate = async (
  tenderId: string,
  params: { uploadType?: string; isOpenForAmendment?: boolean; supplierIds?: string } = {}
) => {
  return GET(`${API_BASE_URL}${RFQ_QUOTE_TEMPLATE_FILE}/${tenderId}`, params, 'blob');
};

export type QuoteTemplateSupplier = { id: string; name: string };

// ISS-294486 — the contractors (CFS / ICD names) a vendor can restrict its bulk-quote template to.
// `isSupplierFilterSupported` is false for vendor types without a contractor dimension. Takes the same
// `isOpenForAmendment` tab flag as the template download, so a tab with nothing left to quote is refused
// here with the download's own reason.
export const getQuoteTemplateSuppliers = async (
  tenderId: string,
  params: { isOpenForAmendment?: boolean } = {}
): Promise<{
  isSuccess: boolean;
  data?: { isSupplierFilterSupported: boolean; suppliers: QuoteTemplateSupplier[] };
  errorMessage?: string;
}> => {
  return GET(`${API_BASE_URL}${RFQ_QUOTE_TEMPLATE_SUPPLIERS}/${tenderId}`, params);
};

export const createBulkQuote = async (body: {
  tenderId: string;
  fileUrl: string;
  fileName?: string;
  uploadType?: string;
  // Must match the tab the template was downloaded from — the server rejects rows belonging to the
  // other tab, and the matrix vendor types rebuild the expected template with it.
  isOpenForAmendment?: boolean;
}) => {
  return POST(`${API_BASE_URL}${RFQ_QUOTE_BULK_CREATE}`, body);
};

export const sendQuote = async (body: {
  quoteId: string;
  tenderId: string;
  rfqIds?: string[];
  message?: string;
  destinationPortIds?: string[];
  originPortIds?: string[];
  containerSizeList?: string[];
  bidCountFilter?: string;
  incoterms?: string[];
  ffShippingLineList?: string[];
  supplierList?: string[];
}) => {
  return POST(`${API_BASE_URL}${RFQ_QUOTE_SEND}`, body);
};

export interface BulkSendQuoteResultItem {
  quoteId: string;
  success: boolean;
  error?: string;
}

export interface BulkSendQuoteResponse {
  successCount: number;
  failCount: number;
  results: BulkSendQuoteResultItem[];
}

export const bulkSendQuote = async (body: {
  tenderId: string;
  quoteIds: string[];
  message?: string;
}) => {
  return POST(`${API_BASE_URL}${RFQ_QUOTE_BULK_SEND}`, body);
};

export const revokeQuote = async (body: { rfqId: string; quoteId: string }) => {
  return POST(`${API_BASE_URL}${RFQ_QUOTE_REVOKE}`, body);
};

export const getLineItemFormFields = async (tenderId: string) => {
  return GET(`${API_BASE_URL}${RFQ_LINE_ITEM_FORM_FIELDS}`, { tenderId });
};

export const fetchTenderLineItems = async ({
  tenderId,
  page = 1,
  pageSize = 20,
  originPortIds = [],
  destinationPortId = null,
  incoterm = null,
  status = null,
  filter = null,
  containerSize = null,
  containerType = null,
  round = null,
  isOpenForAmendment = false,
}: {
  tenderId: string | number;
  page?: number;
  pageSize?: number;
  originPortIds?: string[];
  destinationPortId?: string | null;
  incoterm?: string | null;
  status?: string | null;
  /** Sidebar bucket (TO_BE_FINALISED, NO_BIDS_RECEIVED, …). 'ALL' / null means no narrowing. */
  filter?: string | null;
  containerSize?: string | null;
  containerType?: string | null;
  round?: number | null;
  isOpenForAmendment?: boolean;
}) => {
  const params: {
    tenderId: string | number;
    page: number;
    pageSize: number;
    originPortIds?: string;
    destinationPortId?: string | null;
    incoterm?: string | null;
    status?: string | null;
    filter?: string;
    containerSize?: string | null;
    containerType?: string | null;
    round?: number;
    isOpenForAmendment?: boolean;
  } = { tenderId, page, pageSize };
  if (originPortIds && originPortIds.length) params.originPortIds = originPortIds.join(',');
  if (destinationPortId) params.destinationPortId = destinationPortId;
  if (incoterm) params.incoterm = incoterm;
  if (status) params.status = status;
  // 'ALL' is the backend default — omitted so an unfiltered request keeps its plain indexed count.
  if (filter && filter !== 'ALL') params.filter = filter;
  if (containerSize) params.containerSize = containerSize;
  if (containerType) params.containerType = containerType;
  if (round) params.round = round;
  // Always sent explicitly: true on the Amended tab, false on Main RFQ.
  params.isOpenForAmendment = !!isOpenForAmendment;
  return GET(`${API_BASE_URL}${RFQ_LINE_ITEM_FETCH}`, params);
};

export const editTenderLineItemApi = async (lineItemId: string, params: Record<string, any>) => {
  return PATCH(`${API_BASE_URL}${RFQ_LINE_ITEM_FETCH}/${lineItemId}`, params);
};

export const sendLineItemApi = async (params: {
  tenderId: string;
  lineItemId: string;
  vendorOrgIds: string[];
  deadline: string;
  message?: string;
  /**
   * ISS-291576 — send the line item's AMENDMENT (rfq-next Amended tab) rather than a fresh RFQ round.
   * `vendorOrgIds` must be a subset of the row's `amendmentVendors`; `'ALL'` resolves server-side to exactly
   * those vendors. Rejected if the amendment has already been sent.
   */
  isOpenForAmendment?: boolean;
}) => {
  return POST(`${API_BASE_URL}${RFQ_LINE_ITEM_SEND}`, params);
};

export type BulkSendLineItemFailureReason = 'NOT_FOUND' | 'INVALID_STATUS';

export interface BulkSendLineItemFailure {
  lineItemId: string;
  reason: BulkSendLineItemFailureReason;
  statusValue?: string;
}

export interface BulkSendVendorSuccess {
  vendorOrgId: string;
  rfqId: string;
  action: 'inserted' | 'updated';
}

export interface BulkSendLineItemResult {
  lineItemId: string;
  successCount: number;
  failureCount: number;
  failureArray: Array<{ vendorOrgId: string; reason: string }>;
  successArray: BulkSendVendorSuccess[];
}

export interface BulkSendLineItemsResponse {
  successCount: number;
  failureCount: number;
  failureArray: BulkSendLineItemFailure[];
  results: BulkSendLineItemResult[];
}

export const bulkSendLineItemsApi = async (params: {
  tenderId: string;
  lineItemIds: string[];
  vendorOrgIds: string[];
  deadline: string;
  message?: string;
}) => {
  return POST(`${API_BASE_URL}${RFQ_LINE_ITEM_BULK_SEND}`, params);
};

export const getTenderFormFields = async (params: {
  mode: string;
  movementType: string;
  subType?: string;
  vendorType: string;
}) => {
  return GET(`${API_BASE_URL}${RFQ_TENDER_FORM_FIELDS}`, params);
};

export const createTender = async (payload: Record<string, unknown>) => {
  return POST(`${API_BASE_URL}${RFQ_TENDER_CREATE}`, payload);
};

import { CreateLineItemPayload } from 'src/components/pages/RFQ/common/LineItemModal/LineItemModal.types';

export const createLineItem = async (payload: CreateLineItemPayload) => {
  return POST(`${API_BASE_URL}${RFQ_LINE_ITEM_CREATE}`, payload);
};

export const bulkUploadLineItems = async (body: { tenderId: string; fileUrl: string; fileName?: string }) => {
  return POST(`${API_BASE_URL}${RFQ_LINE_ITEM_BULK_UPLOAD}`, body);
};

export const downloadLineItemTemplate = async (tenderId: string) => {
  return GET(`${API_BASE_URL}${RFQ_LINE_ITEM_TEMPLATE}`, { tenderId }, 'blob');
};

export const downloadLineItemQuotes = async (params: {
  tenderId: string;
  lineItemId: string;
  round?: number;
  // Amended tab only (ISS-291244): restricts the workbook to the amendment's bids. Omitted on the
  // Main tab, where the server then returns the frozen pre-amendment bids instead.
  isOpenForAmendment?: boolean;
}) => {
  return GET(`${API_BASE_URL}${RFQ_LINE_ITEM_QUOTES_DOWNLOAD}`, params, 'blob');
};

export const downloadReferenceQuote = async (params: {
  tenderId: string;
  round?: number;
}) => {
  const { tenderId, ...queryParams } = params;
  return GET(`${API_BASE_URL}${RFQ_REFERENCE_QUOTE_DOWNLOAD}/${tenderId}`, queryParams, 'blob');
};

export const downloadTenderQuotes = async (params: {
  tenderId: string;
  round?: number;
  // Amended tab only (ISS-291244) — see downloadLineItemQuotes.
  isOpenForAmendment?: boolean;
}) => {
  return GET(`${API_BASE_URL}${RFQ_TENDER_QUOTES_DOWNLOAD}`, params, 'blob');
};

export const getTenderDetails = async (tenderId: string) => {
  return GET(`${API_BASE_URL}${RFQ_TENDER_DETAILS}/${tenderId}`);
};

export const editTender = async (tenderId: string, body: Record<string, unknown>) => {
  return PATCH(`${API_BASE_URL}${RFQ_TENDER_DETAILS}/${tenderId}`, body);
};
